import React, {useContext, useMemo, useRef, useState} from "react";
import TablePage from "../tablePage/TablePage";
import dayjs from "dayjs";
import {formatUnixTime} from "../../shared/utils/dayjsUtil";
import GoToUserInfoButton from "../../shared/components/buttons/GoToUserInfoButton";
import SearchParams from "../../shared/components/common/SearchParams";
import {buildUrl} from "../../shared/utils/net";
import {useItemKrTextData, usePackageDataTable} from "../../features/probability/useItemData";
import IsLoading from "../../shared/components/IsLoading";
import ErrorPage from "../../shared/components/ErrorPage";
import {getPaymentLogColumns} from "../../features/logs/columns/paymentLogColumns";
import {AuthContext} from "../../shared/contexts/authContext";

const Refund = () => {
    const {currentUser} = useContext(AuthContext);

    const [rows, setRows] = useState([]);
    const [rowData, setRowData] = useState({});
    const [searchParam, setSearchParam] = React.useState({
        begin: dayjs().subtract(7, 'day').startOf('day').unix(),
        end: dayjs().endOf('day').unix(),
    });
    const [url, setUrl] = useState(buildUrl('/logs/refund', searchParam));

    const refreshRef = useRef(null);
    const {data: krItemTextData, isLoading: isKrItemTextDataLoading, error: krItemTextDataError} = useItemKrTextData();
    const {data: packageData, isLoading: isPackageDataLoading, error: packageDataError} = usePackageDataTable();

    const handleSearch = () => {
        setUrl(buildUrl('/logs/refund', searchParam));
    }

    const handleSetSearchParam = (key, value) => {
        setSearchParam(prevState => ({
            ...prevState,
            [key]: value
        }));
    }
    if (isKrItemTextDataLoading || isPackageDataLoading) return <IsLoading/>;
    const error = krItemTextDataError || packageDataError;
    if (error) return <ErrorPage error={error}/>;

    const columns = [
        {
            title: 'PID',
            dataIndex: 'pid',
            search: true,
        },
        {
            title: '닉네임',
            dataIndex: 'name',
            search: true,
        },
        ...getPaymentLogColumns(packageData, krItemTextData[currentUser.target]),
        {
            title: '국가',
            dataIndex: 'country',
        },
        {
            title: '환불 날짜',
            dataIndex: 'refundDate',
            render: (time) => formatUnixTime(time),
        },
        {
            title: '유저 정보',
            dataIndex: 'pid',
            render: (pid) => <GoToUserInfoButton pid={pid}/>,
        },
    ];


    const props = {
        columns,
        rows,
        setRows,
        rowData,
        setRowData,
        refreshRef,
        url,
    }

    return (
        <>
            <SearchParams
                searchParam={searchParam}
                handleSetSearchParam={handleSetSearchParam}
                handleSearch={handleSearch}
            />
            <TablePage {...props} />
        </>
    );
};

export default Refund;